import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { LoanLiquidityState, LoanLiquidityViewFilters } from './types';

export const initialState: LoanLiquidityState = {
  viewFilter: 'supportedPairs',
};

export const loanLiquiditySlice = createSlice({
  name: 'liquidity',
  initialState,
  reducers: {
    setViewFilter: (state, action: PayloadAction<LoanLiquidityViewFilters>) => {
      state.viewFilter = action.payload || 'supportedPairs';
    },
  },
});

export const liquidityActions = {
  ...loanLiquiditySlice.actions,
};

export default loanLiquiditySlice.reducer;
